import { AdminLoginPage } from '@/Admin/Auth/AdminLoginPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/Login')({
    component: RouteComponent,
})

function RouteComponent() {
    return <AdminLoginPage />
}
